import { useEffect, useState } from 'react';

/**
 * PARCHE CABSEN (2026-09-14): devuelve true mientras la ventana cumple la consulta CSS indicada
 * (p. ej. '(max-width: 767.98px)'), y se actualiza al girar el telefono o redimensionar la ventana.
 * Se usa en la lista de estudios para elegir entre la presentacion de escritorio y la de movil sin
 * duplicar el DOM.
 */
export default function useMediaQuery(query: string): boolean {
  const consultar = () =>
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia(query).matches;

  const [coincide, setCoincide] = useState<boolean>(consultar);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const lista = window.matchMedia(query);
    const alCambiar = (evento: MediaQueryListEvent) => setCoincide(evento.matches);
    setCoincide(lista.matches);
    lista.addEventListener('change', alCambiar);
    return () => lista.removeEventListener('change', alCambiar);
  }, [query]);

  return coincide;
}

/** Consulta compartida por la lista de estudios: por debajo del "md" de Tailwind (768 px). */
export const CONSULTA_MOVIL = '(max-width: 767.98px)';

/**
 * Consulta de los visores (ViewerLayoutEstrecho): por debajo del "lg" de Tailwind (1024 px), es decir,
 * telefonos en vertical y en horizontal y tabletas en vertical. La cabecera del visor completo necesita
 * unos 850 px y los dos paneles laterales 560 px, asi que por debajo de 1024 no caben con la imagen.
 */
export const CONSULTA_VISOR_ESTRECHO = '(max-width: 1023.98px)';
